/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ContactedInputs */

const cs_enum_contacted = /** @type {(inputs: Enum_ContactedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktován`)
};

const en_enum_contacted = /** @type {(inputs: Enum_ContactedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacted`)
};

/**
* | output |
* | --- |
* | "Contacted" |
*
* @param {Enum_ContactedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_contacted = /** @type {((inputs?: Enum_ContactedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ContactedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_contacted(inputs)
	return cs_enum_contacted(inputs)
});